// @flow

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isNil, complement, any, propIs, propEq, prop } from "ramda";
import classNames from "classnames";
import { useI18n } from "@quantum/i18n";
import { includesIn, isMultiplasMedidasSelecionadas } from "../../../util";
import {
  CASA_DECIMAL_PADRAO_NORMAL,
  CASA_DECIMAL_PADRAO_SERIES,
  MEDIDAS_SEM_CASAS_DECIMAIS,
  MODO_APP_SERIES,
} from "../../../model";

import {
  getCasasDecimaisSelecionado,
  getListaDeCasasDecimais,
  selecionarCasasDecimaisMedida,
  getMedidaSelecionada,
  getModoApp,
} from "../../../state";

import SelectInput from "../../comum/SelectInput";

export default (props: *) => {
  const dispatch = useDispatch();
  const { translate } = useI18n();
  const medidaSelecionada = useSelector(getMedidaSelecionada);
  const opcoes = useSelector(getListaDeCasasDecimais);
  const opcoesTraduzidas = opcoes.map(opcao => {
    return {
      ...opcao,
      descricao: translate(opcao.descricao) || opcao.descricao,
    };
  });
  const modoApp = useSelector(getModoApp);
  const casasDecimais = useSelector(getCasasDecimaisSelecionado);

  const casasDecimaisDefault =
    modoApp === MODO_APP_SERIES
      ? CASA_DECIMAL_PADRAO_SERIES
      : CASA_DECIMAL_PADRAO_NORMAL;

  useEffect(() => {
    const casas = isNil(casasDecimais) ? casasDecimaisDefault : casasDecimais;
    dispatch(selecionarCasasDecimaisMedida(casas));
  }, [props.nomeMedida, casasDecimais, casasDecimaisDefault, dispatch]);

  const gerarArrayDeFormatacoes = () => {
    return propIs(Array, "medidasSecundarias", medidaSelecionada)
      ? prop("medidasSecundarias", medidaSelecionada).map(
          medida => medida.formatacao
        )
      : [];
  };

  const isMedidaOuSecundariasComCasasDecimais = () => {
    return (
      medidaSelecionada &&
      !isMultiplasMedidasSelecionadas(medidaSelecionada) &&
      (!MEDIDAS_SEM_CASAS_DECIMAIS.includes(medidaSelecionada.formatacao) ||
        (complement(propEq)(
          "tipoMedidasSecundarias",
          "PERIODO_SERIE",
          medidaSelecionada
        ) &&
          propIs(Array, "medidasSecundarias", medidaSelecionada) &&
          any(complement(includesIn(MEDIDAS_SEM_CASAS_DECIMAIS)))(
            gerarArrayDeFormatacoes()
          )))
    );
  };

  if (!(medidaSelecionada && isMedidaOuSecundariasComCasasDecimais())) {
    return null;
  }

  return (
    <>
      <div className={classNames("ConfiguracaoMedida", props.className)}>
        <label
          className="ConfiguracaoMedida__label-nowrap"
          htmlFor="casasDecimais"
        >
          {translate("configuracaoRelatorio.casasDecimais")}
        </label>
        <SelectInput
          className="ConfiguracaoMedida__input-select"
          value={isNil(casasDecimais) ? casasDecimaisDefault : casasDecimais}
          onChange={casas => dispatch(selecionarCasasDecimaisMedida(casas))}
          options={opcoesTraduzidas}
          campoId="id"
          campoDescricao="descricao"
          searchable={false}
          {...props}
        />
      </div>
    </>
  );
};
